import { render } from "./ImplementedProgramsTable.vue?vue&type=template&id=ab224dbc&scoped=true"
import script from "./ImplementedProgramsTable.vue?vue&type=script&lang=js"
export * from "./ImplementedProgramsTable.vue?vue&type=script&lang=js"

import "./ImplementedProgramsTable.vue?vue&type=style&index=0&id=ab224dbc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab224dbc"]])

export default __exports__